<template>
  <div id="tape">
    <H3>
      订单列表
      <template v-slot:suffix>
        <a-tooltip>
          <template slot="title">
            <a href="tel:13715168779">Nicole Chen: 13715168779</a>
          </template>
          <span class="customer">
            <a-icon type="customer-service" style="margin-right:8px;" />联系客服
          </span>
        </a-tooltip>
      </template>
    </H3>
    <div class="toolbar filter-container" v-if="user.role != 8">
      <a-input
        v-model="search.order_num"
        placeholder="批次号"
        class="filter-item"
        clearable
        style="width:110px"
        @change="fetchTapeProject()"
      ></a-input>
      <a-input
        v-model="search.title"
        placeholder="项目名称"
        class="filter-item"
        clearable
        style="width:200px"
        @change="fetchTapeProject()"
      ></a-input>
      <a-select
        v-if="false"
        v-model="search.supplier_id"
        multiple
        collapse-tags
        placeholder="选择工厂名称"
        clearable
        filterable
        style="width: 220px"
        class="filter-item"
        @change="fetchTapeProject()"
      >
        <a-option v-for="item in suppliers" :key="item.key" :label="item.key" :value="item.val" />
      </a-select>
      <a-button type="primary" class="filter-item" @click="fetchTapeProject">搜索</a-button>
      <span
        class="filter-item cus-switch"
        :class="{active:search.onlyMeasure}"
        @click="changeOnlyMeasure"
      >只看需要测量的订单</span>
      <a-button
        v-if="false"
        @click="toCreateTapeProject"
        class="filter-item"
        type="senkoo2"
      >创建Tape项目</a-button>
    </div>

    <div class="shops">
      <a-table
        :dataSource="data"
        rowKey="id"
        ref="tapeorderTaple"
        @selection-change="handleSelectionChange"
        class="shops-table"
      >
        <a-table-column data-index="orders[0].shop_no" title="店号"></a-table-column>
        <a-table-column data-index="orders[0].shop_title" title="店铺名称">
          <a-button
            slot-scope="text,record"
            type="link"
            @click="$router.push({name:'orderDetail',params:{id:record.id}})"
          >{{text}}</a-button>
        </a-table-column>
        <a-table-column data-index="title" title="项目名称"></a-table-column>
        <a-table-column data-index="created_at" title="下单时间">
          <template slot-scope="text">{{text*1000|datetime}}</template>
        </a-table-column>
        <a-table-column data-index="deadline" title="截止时间">
          <template slot-scope="text">{{text*1000|datetime}}</template>
        </a-table-column>
        <a-table-column data-index="orders" key="count" title="安装画面数">
          <template slot-scope="text">
            涉及
            <a-button type="link" @click="toShowImage(text)">{{text.reduce((p,c) => p+c.count,0)}}</a-button>个画面
          </template>
        </a-table-column>
        <a-table-column data-index="factory" title="工厂"></a-table-column>
        <a-table-column data-index="needMeasure" title="是否需要测量" />
        <a-table-column data-index="state" title="状态" />
        <a-table-column data-index="id" title="操作">
          <template slot-scope="text,record,index">
            <a-tooltip title="删除订单">
              <a-button
                v-if="user.id == record.user_id"
                type="dashed"
                icon="delete"
                shape="circle"
                @click="toDeleteTapeProject(record,index)"
                class="icon-btn"
              ></a-button>
            </a-tooltip>
            <a-tooltip title="编辑订单">
              <a-button
                type="dashed"
                icon="edit"
                shape="circle"
                @click="$router.push({name:'home',params:{id:text}})"
                class="icon-btn"
              ></a-button>
            </a-tooltip>
            <a-tooltip title="预览报告">
              <a-button
                type="dashed"
                icon="file-pdf"
                shape="circle"
                @click="$router.push({name:'orderReview',params:{id:text},query:{no:record.shop_no||user.login_name}})"
                class="icon-btn"
              ></a-button>
            </a-tooltip>
            <a-tooltip title="下载点位明细">
              <a-button
                type="dashed"
                icon="download"
                shape="circle"
                :loading="loading"
                @click="toDownload(record)"
                class="icon-btn"
              ></a-button>
            </a-tooltip>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <ImageList :visible.sync="isShowImg" :imgs="showImgUrls" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import H3 from "./H3";
import ImageList from "@/components/ImageList";
import { generateExcel } from "@/util";
export default {
  components: { H3, ImageList },
  data() {
    return {
      data: [],
      page: { total: 0 },
      search: {
        order_num: "",
        title: "",
        onlyMeasure: false,
        supplier_id: ""
      },
      suppliers: [],
      choosedTapeOrder: [],
      showCreateProject: false,
      loading: false,
      showTapeProject: false,
      isShowImg: false,
      showImgUrls: []
    };
  },
  created() {
    this.fetchTapeProject();
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions("shop", [
      "getTapeOrder",
      "handleTapeOrder",
      "deleteTapeProject"
    ]),
    exportTapeImage(data1,row) {
      const map = {
        order_num: "订单编号",
        row_id: "序号",
        shop_no: "店铺结算编号",
        shop_title: "店铺名称",
        province_title: "省份",
        city_title: "城市",
        num: "画面编号",
        skcode: "贩促物编号",
        kind: "安装物料类型",
        material: "材料",
        location: "所处店铺位置",
        width: "可见宽",
        height: "可见高",
        view_width: "完成宽",
        view_height: "完成高",
        count: "物料数量",
        next_process: "后道工艺",
        need_install: "安装",
        id: "tape_order_id"
      };
      const keys = Object.keys(map);
      const header = Object.values(map);
      const data = data1.map((m, i) =>
        keys.map(k => (k == "row_id" ? i + 1 : m[k]))
      );
      const filename = `SenkooCRM-${row.title}-${row.orders[0].shop_no}-店铺点位清单`;
      return generateExcel({ data, header, filename });
    },
    toDownload(row) {
      // console.log("to download:", row);
      this.$confirm({
        title: "确认下载点位明细么？",
        onOk: () => {
          // console.log("onOK:", row);
          const param = { tape_project_id: row.id, kind: "export" };
          this.loading = true;
          this.getTapeOrder(param).then(res => {
            this.loading = false;
            // console.log("export data:", res);
            if (res.code === 200) {
              this.exportTapeImage(res.data,row);
            }
          });
        },
        onCancel: () => {}
      });
    },
    toShowImage(orders) {
      console.log("to show imag:", orders);
      this.isShowImg = true;
      this.showImgUrls = orders
        .map(m => m.current_image)
        .join(",")
        .split(",");
    },
    handleSelectionChange(val) {
      this.choosedTapeOrder = val;
    },
    toCreateTapeProject() {
      this.showTapeProject = true;
    },
    createdProject() {
      this.fetchTapeProject();
    },
    changeOnlyMeasure() {
      this.search.onlyMeasure = !this.search.onlyMeasure;
      this.fetchTapeProject();
    },
    toCreateTapeOrderProject() {
      if (this.choosedTapeOrder.length <= 0) {
        this.$confirm({
          title:
            "本次生成项目将会包括系统内所有未下单的点位图片，确认继续生成项目么？",
          onOk: () => {
            this.showCreateProject = true;
          },
          onCancel: () => {}
        });
      } else {
        this.$confirm({
          title: "生成项目会造成资源损耗，确认继续生成项目么？",
          onOk: () => {
            this.showCreateProject = true;
          },
          onCancel: () => {}
        });
      }
    },
    toDeleteTapeProject(row, $index) {
      // console.log("to delete tape order:", row, $index);
      this.$confirm({
        title: "项目删除后不可恢复，确定删除？？？",
        onOk: () => {
          const order = { id: row.id, kind: "delete" };
          this.deleteTapeProject(order).then(res => {
            // console.log("log res:", res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.fetchTapeProject();
            }
          });
        },
        onCancel: () => {}
      });
    },
    chooseOnlyMeause(e) {
      this.search.onlyMeasure = !this.search.onlyMeasure;
    },
    handleSelect(e) {
      // console.log("change supplier:", e);
    },
    // btnSearch() {
    //   // console.log("log:");
    //   this.fetchTapeOrder();
    // },
    showName(e) {
      this.$router.push({ path: "showPoint", query: { sid: e.no } });
    },
    fetchTapeProject(param = {}) {
      if (this.search.order_num) {
        param.order_num = this.search.order_num;
      }
      if (this.search.title) {
        param.title = this.search.title;
      }
      if (this.search.onlyMeasure) {
        param.only_measure = this.search.onlyMeasure;
      }
      if (this.user.role == 8) {
        param.shop_no = this.user.login_name;
      }
      param.project_type = 8;
      this.$store.dispatch("shop/getTapeProject", param).then(res => {
        this.$nextTick(() => {});
        this.data = res.data.map(m => ({
          ...m,
          factory: "上海释空",
          needMeasure: "否",
          state: "下单"
        }));
        this.page = res.page;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#tape {
  // padding: 0 24px 24px;
  .customer {
    color: #27b0af;
    cursor: pointer;
  }
  h3 {
    padding-bottom: 15px;
    border-bottom: 1px solid #d8d8d8;
  }
  .toolbar {
    margin-bottom: 20px;
    // border: 1px dashed red;
    text-align: left;
    > * {
      margin-right: 12px;
    }
    .cus-switch {
      padding: 5px 10px;
      border-radius: 4px;
      color: #666;
      border: 1px solid #999;
      cursor: pointer;
    }
    .cus-switch:hover {
      border-color: #516fad;
      color: #516fad;
    }
    .cus-switch.active {
      border-color: #516fad;
      color: #516fad;
    }
  }
  .shops,
  .images {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .shops {
    // border: 1px dashed red;
    background: #fff;
    .shops-table {
      width: 100%;
      .icon-btn {
        margin-right: 12px;
      }
      .num {
        color: #29afaf;
        font-weight: 500;
        font-size: larger;
      }
    }
  }
  .images {
    align-items: center;
    border: 1px solid #f2f2f2;
    height: 500px;
    width: 100%;
    img {
      width: 400px;
      box-sizing: border-box;
      padding: 12px;
    }
    .imgs {
      width: 100%;
    }
  }
}
</style>
